import { checkResponse, hashCode } from "src/components/js/statics1";

export default class starsClass {
  constructor(stars = 0, palaute = undefined) {
    this.stars = stars;
    this.palaute = palaute;
  }

  get starsHash() {
    const stars = this.stars || 6;
    const palaute = hashCode(this.palaute);
    const tot = stars + palaute;
    return tot;
  }
}
export async function keikkaStars_getPersonStars(keikkaId, personId, token) {
  const url = "/api/keikka/stars/getPersonStars/" + keikkaId + "/" + personId;
  const response = await fetch(import.meta.env.VITE_SERVER_URL + url, {
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
  });
  const cResponse = await checkResponse(response, "starsClass.js:getKeikkaPersonStars");
  if (!cResponse.success) return false;
  const result = cResponse.data;
  return result;
}

export async function keikkaStars_getLastVotedDate(_stars, deliveryDate) {
  let _lastVotedDate = null;
  for (let i = 0; i < _stars.length; i++) {
    if (_lastVotedDate === null) _lastVotedDate = _stars[i].entryTime;
    else if (_lastVotedDate < _stars[i].entryTime) _lastVotedDate = _stars[i].entryTime;
  }
  if (_lastVotedDate !== null) _lastVotedDate = new Date();
  if (deliveryDate > _lastVotedDate) _lastVotedDate = deliveryDate;
  return _lastVotedDate;
}

export async function keikkaStars_savePersonStarsToDB(category, stars, keikkaId, personId, token) {
  if (stars.stars === null || stars.stars === undefined) stars.stars = 0;
  // update dbo.keikkaPersonStars
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      keikkaId: keikkaId,
      personId: personId,
      category: category,
      stars: stars.stars,
      palaute: stars.palaute,
    }),
  };
  const response = await fetch(
    import.meta.env.VITE_SERVER_URL + "/api/keikka/stars/set",
    requestOptions
  ).catch((error) => {
    console.error("Error:", error);
  });
  if (!(await checkResponse(response).success)) return false;
}

export async function keikkaStars_fetch(keikkaId, token) {
  const url = "/api/keikka/stars/getStars/" + keikkaId;
  const response = await fetch(import.meta.env.VITE_SERVER_URL + url, {
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
  });
  const cResponse = await checkResponse(response, "starsClass.js:getKeikkaStars");
  if (!cResponse.success) return false;
  const result = cResponse.data;
  if (result.length > 0) return result[0].stars;
  else return null;
}
